import $ from 'jquery'

document.addEventListener('DOMContentLoaded', () => {
    $('.contactSlider .contact').click((ev: JQuery.ClickEvent) => {
        ev.stopPropagation()
    })

    $('.contactSlider').click((ev: JQuery.ClickEvent) => {
        ev.stopPropagation()
        $('.contact').toggleClass('openContact')
        $(ev.currentTarget).toggleClass('leftContactSlide')
    })

    document.body.addEventListener('click', () => {
        if ($('.contact').hasClass('openContact')) {
            $('.contact').removeClass('openContact')
            $('.contactSlider').removeClass('leftContactSlide')
        }
    })
})
